/**
 * Hook to detect if there hasn't been any user activity within 45 seconds.
 *
 * ## Triggers
 *
 *  - `idle-timer-expired` When there hasn't been any user touch activity
 *  - `modal-countdown-timer-expired` When the final countdown expires
 *
 * ## Handles
 *
 *  - `start-idle-timer` Starts a timer that resets on user interaction
 *  - `start-modal-countdown-timer` Starts the modal final countdown timer
 *
 * ### Example
 *
 *   <div
 *     id="user-activity-global-region"
 *     phx-hook="IdleKioskTimer"
 *     data-target={@myself}
 *     data-remaining-seconds-text="remaining-seconds-text"
 *   >
 */

export const IdleKioskTimer = {
  mounted() {
    idle_duration = 60_000;
    modal_duration = 15_000;

    let startIdleTimer = () => {
      this.resetIdleTimer();
      window.addEventListener("touchstart", this.resetIdleTimer);
    };

    this.resetIdleTimer = () => {
      clearTimeout(this.idleTimer);
      clearInterval(this.secondInterval);
      this.idleTimer = setTimeout(() => idleTimerExpired(), idle_duration);
    };

    let idleTimerExpired = () => {
      if (this.el.dataset.target) {
        this.pushEventTo(this.el.dataset.target, "idle-timer-expired", {});
      } else {
        this.pushEvent("idle-timer-expired", {});
      }

      window.removeEventListener("touchstart", this.resetIdleTimer);
    };

    // Modal Countdown Timer
    let startModalCountdownTimer = () => {
      secondsRemainingText = document.getElementById(
        this.el.dataset.remainingSecondsText,
      );

      // Set the initial remaining seconds text
      this.secondsRemaining = modal_duration / 1_000;
      secondsRemainingText.innerText = this.secondsRemaining;

      // Start an interval that will count down to zero, updating the remaining
      // seconds text. Once zero seconds is hit, inform the LiveView which will
      // kill off the hook.
      this.secondInterval = setInterval(() => {
        this.secondsRemaining = this.secondsRemaining - 1;
        secondsRemainingText.innerText = this.secondsRemaining;

        if (this.secondsRemaining < 1) {
          modalTimerExpired();
        }
      }, 1_000);
    };

    let modalTimerExpired = () => {
      if (this.el.dataset.target) {
        this.pushEventTo(
          this.el.dataset.target,
          "modal-countdown-timer-expired",
          {},
        );
      } else {
        this.pushEvent("modal-countdown-timer-expired", {});
      }
    };

    this.handleEvent("start-idle-timer", startIdleTimer);
    this.handleEvent("start-modal-countdown-timer", startModalCountdownTimer);
  },

  destroyed() {
    clearTimeout(this.idleTimer);
    clearInterval(this.secondInterval);
    window.removeEventListener("touchstart", this.resetIdleTimer);
  },
};

export default IdleKioskTimer;
